import timestring from 'timestring';

export function convertTimeStringToMinutes(
  timeString: string,
  options?: {
    minimum?: number;
    maximum?: number;
  }
): string {
  const { minimum, maximum } = options || {};

  /**
   * The `timestring` library automatically assumes any number
   * without a time unit ('h', 'mins', 'seconds', etc.) is in
   * milliseconds. This prevents that and instead assumes it is
   * in minutes.
   */
  const rgx = new RegExp('^([0-9]*)[.]?([0-9]*)$', 'gm');
  const vettedTimeString = rgx.test(timeString)
    ? `${timeString} minutes`
    : timeString;

  const vettedOptions: {
    minimum?: number;
    maximum?: number;
  } = {};

  /**
   * Set the minimum if it exists in the options; and if the maximum is also set,
   * ensure that the minimum is less than or equal to the maximum
   */
  if (minimum) {
    vettedOptions['minimum'] = maximum && minimum > maximum ? maximum : minimum;
  }

  if (maximum || maximum === 0) {
    vettedOptions['maximum'] = maximum;
  }

  try {
    let minutes = timestring(vettedTimeString, 'm') as number;
    minutes = Math.round(minutes);

    if (vettedOptions['minimum'] && minutes < vettedOptions['minimum']) {
      return vettedOptions['minimum'].toString();
    }
    if (
      vettedOptions.hasOwnProperty('maximum') &&
      minutes > vettedOptions['maximum']
    ) {
      return vettedOptions['maximum'].toString();
    }

    return minutes.toString();
  } catch (err) {
    return timeString;
  }
}
